import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer-container">
      {/* Company Info */}
      <div className="footer-section">
        <h4>Any Time Movers AU</h4>
        <p>Your trusted partner for stress-free moving.</p>
      </div>

      {/* Quick Links */}
      <div className="footer-section">
        <h4>Quick Links</h4>
        <ul>
          {[
            { label: 'Home', to: '/' },
            { label: 'Services', to: '/services' },
            { label: 'Get a Quote', to: '/quote' },
            { label: 'About Us', to: '/about' },
            { label: 'Gallery', to: '/gallery' },
            { label: 'Contact', to: '/contact' },
            { label: 'Privacy Policy', to: '/privacy-policy' },
          ].map(({ label, to }) => (
            <li key={to}>
              <Link to={to}>
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-section">
        <h4>Contact Us</h4>
        <a href="tel:0469303269" className="contact-link">
          📞 0469303269
        </a>
        <p>✉️ info@anytimemovers.com.au</p>
        <p>🏢 Salisbury, Adelaide</p>

        {/* Social Icons */}
        <div className="social-links">
          {[
            {
              href: 'https://www.facebook.com/profile.php?id=61570093314772',
              alt: 'Facebook',
              src: 'facebook.svg',
            },
            {
              href: 'https://instagram.com',
              alt: 'Instagram',
              src: 'instagram.svg',
            },
            {
              href: 'https://www.tiktok.com/@anytimemovers0469303269',
              alt: 'TikTok',
              src: 'tiktok.svg',
            },
          ].map(({ href, alt, src }) => (
            <a
              key={alt}
              href={href}
              target="_blank"
              rel="noreferrer"
            >
              <img src={src} alt={alt} />
            </a>
          ))}
        </div>
      </div>
    </div>

    {/* Bottom Section */}
    <div className="footer-bottom">
      <div className="footer-flags">
        <img src="/flag-1.png" alt="Flag 1" />
        <img src="/flag-2.png" alt="Flag 2" />
        <img src="/flag-3.png" alt="Flag 3" />
      </div>
      <p className="footer-copyright">
        © {new Date().getFullYear()} Any Time Movers AU. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
